/* Keep native disclosure behavior as the no-JavaScript fallback. */
(() => {
  function enhanceDescriptions(root) {
    root.querySelectorAll('[data-newsed-description]').forEach((details) => {
      if (details.classList.contains('is-enhanced')) return;
      const summary = details.querySelector('summary');
      const content = details.querySelector('[data-newsed-description-content]');
      const close = details.querySelector('[data-newsed-description-close]');
      if (!summary || !content || !close) return;
      close.hidden = false;
      details.classList.add('is-enhanced');
      details.addEventListener('toggle', () => {
        if (details.open) content.focus({ preventScroll: true });
      });
      close.addEventListener('click', () => {
        details.open = false;
        summary.focus({ preventScroll: true });
        const bounds = summary.getBoundingClientRect();
        if (bounds.top < 0 || bounds.bottom > window.innerHeight) {
          summary.scrollIntoView({ block: 'center' });
        }
      });
    });
  }
  enhanceDescriptions(document);
  document.addEventListener('shopify:section:load', (event) => enhanceDescriptions(event.target));
})();
